var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header android-hack"},[(_vm.showBack)?_c('span',{staticClass:"icon-back",on:{"click":_vm.handleReturn}}):_vm._e(),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }